/* eslint-disable prettier/prettier */
const fillEnvVarsOnRuntime = import.meta.env.VITE_FILL_ENV_VARS_ON_RUNTIME === 'true';
export const env: ImportMetaEnvCustom = {
  VITE_FILL_ENV_VARS_ON_RUNTIME: import.meta.env.VITE_FILL_ENV_VARS_ON_RUNTIME,
  // The following are only available at build time, unless VITE_IS_RUNTIME_ENV is set to "true"
  VITE_API_PROT: fillEnvVarsOnRuntime ? "${VITE_API_PROT}" : import.meta.env.VITE_API_PROT,
  VITE_API_HOST: fillEnvVarsOnRuntime ? "${VITE_API_HOST}" : import.meta.env.VITE_API_HOST,
  VITE_API_PORT: fillEnvVarsOnRuntime ? "${VITE_API_PORT}" : import.meta.env.VITE_API_PORT,
  VITE_API_PATH: fillEnvVarsOnRuntime ? "${VITE_API_PATH}" : import.meta.env.VITE_API_PATH,
  VITE_QR_URL: fillEnvVarsOnRuntime ? "${VITE_QR_URL}" : import.meta.env.VITE_QR_URL,
  VITE_API_URL: fillEnvVarsOnRuntime ? "${VITE_API_URL}" : import.meta.env.VITE_API_URL,
  VITE_SENTRY_DSN: fillEnvVarsOnRuntime ? "${VITE_SENTRY_DSN}" : import.meta.env.VITE_SENTRY_DSN,
  VITE_SENTRY_ENVIRONMENT: fillEnvVarsOnRuntime ? "${VITE_SENTRY_ENVIRONMENT}" : import.meta.env.VITE_SENTRY_ENVIRONMENT,
  VITE_SENTRY_RELEASE: fillEnvVarsOnRuntime ? "${VITE_SENTRY_RELEASE}" : import.meta.env.VITE_SENTRY_RELEASE,
  VITE_SENTRY_TRACES_SAMPLE_RATE: fillEnvVarsOnRuntime ? "${VITE_SENTRY_TRACES_SAMPLE_RATE}" : import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,
  BASE_URL: fillEnvVarsOnRuntime ? "${BASE_URL}" : import.meta.env.BASE_URL,
};
export default env;
